export const unlimitedMailBoxes = 9999;
export const attachmentNameMaxLength = 20;
export const maxTableRowsCount = 20;
export const customTypeIdMeasure = 1000;
